import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import * as yup from "yup";

export interface IFlagSensorMMFormMeta {
    necessity: FormInputMeta;
    action_failure: FormInputMeta;

}

const flagSensorMMFormMeta = {} as IFlagSensorMMFormMeta;

flagSensorMMFormMeta.necessity = {
    name: "necessity",
    type: "select",
    label: "Besoin",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};

flagSensorMMFormMeta.action_failure = {
    name: "action_failure",
    type: "select",
    label: "Action Echec",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !"),
};


export default flagSensorMMFormMeta;